import React, { useContext } from 'react'
import { IconContext } from 'react-icons'
import { FaSpinner } from 'react-icons/fa'

import { PanelStyleContext } from '../panel/PanelStyleContext'
import { ParameterContext } from '../../wrappers/ParameterContext'

const FormResultsSummary = ({
    name,
    filterResultsCount,
    filterResultsLoading,
    filterExpanded,
}) => {
    const { colorClass } = useContext(PanelStyleContext)
    const { refinedParams } = useContext(ParameterContext)

    return (
        <div
            className={`field is-horizontal is-grouped is-grouped-centered ${
                filterExpanded ? 'is-visible' : 'is-hidden'
            } formResultsSummaryWrapper`}
        >
            <div className="control is-full">
                {!filterResultsLoading ? (
                    <span className="label is-small">
                        This search will produce {` `}
                        <span className="is-loading">
                            {filterResultsCount &&
                            Array.isArray(filterResultsCount)
                                ? filterResultsCount.join(` + `)
                                : filterResultsCount}{' '}
                            {(refinedParams &&
                                Array.isArray(refinedParams) &&
                                refinedParams.length &&
                                name === 'sample' &&
                                'refined') ||
                                ''}{' '}
                            results.
                        </span>
                    </span>
                ) : (
                    <span className="filterResultsLoadingWrapper">
                        <IconContext.Provider
                            value={{
                                className: 'fa-pulse ' + colorClass,
                                size: '1rem',
                                style: {
                                    marginRight: 10,
                                },
                            }}
                        >
                            <FaSpinner />
                        </IconContext.Provider>
                        Loading search results count.
                    </span>
                )}
            </div>
        </div>
    )
}

export default FormResultsSummary
